export const SET_CATEGORIES = 'SET_CATEGORIES'
export const PUSH_NOTIFICATION = 'PUSH'
export const DELETE_NOTIFICATION = 'DELETE'
export const SET_BULK_UPDATE_FIELDS = 'SET_BULK_UPDATE_FIELDS'
export const SET_FEEDBACK_OBJECT = 'SET_FEEDBACK_OBJECT'
export const SET_BULKUPDATE_SUMMARY = 'SET_BULKUPDATE_SUMMARY'
export const SET_RECORD_ACCESS_ERROR = 'SET_RECORD_ACCESS_ERROR'
export const SET_FIELD_ACCESS_ERROR = 'SET_FIELD_ACCESS_ERROR'
export const SET_VALIDATION_ERROR = 'SET_VALIDATION_ERROR'
export const SET_TITLE = 'SET_TITLE'
export const SET_DEFAULT_TITLE = 'SET_DEFAULT_TITLE'
export const SET_SAVE_ERROR = 'SET_SAVE_ERROR'
export const SET_PLACEHOLDER_MESSAGE = 'SET_PLACEHOLDER_MESSAGE'
export const SET_IS_FILL_MISSING_DATES = 'SET_IS_FILL_MISSING_DATES'
export const SET_TRANSLATION = 'SET_TRANSLATION'
export const CLEAR_TRANSLATIONS = 'CLEAR_TRANSLATIONS'
export const SET_DRAG_ACTION = 'SET_DRAG_ACTION'
export const TOGGLE_EDITOR_REFRESH_NEEDED = 'TOGGLE_EDITOR_REFRESH_NEEDED'
export const SET_QUESTIONNAIRE_DATA = 'SET_QUESTIONNAIRE_DATA'
export const SET_CURRENT_PROGRESS = 'SET_CURRENT_PROGRESS'
export const NEW_RECORD_SAVED = 'NEW_RECORD_SAVED'
export const ADD_FAILED_SAVE = 'ADD_FAILED_SAVE'
export const INCREMENT_SAVE_NUMBER = 'INCREMENT_SAVE_NUMBER'
export const RESET_SAVE_DATA = 'RESET_SAVE_DATA'
export const ADD_MODIFIED_RECORD = 'ADD_MODIFIED_RECORD'
export const REMOVE_MODIFIED_RECORD = 'REMOVE_MODIFIED_RECORD'
export const SET_COLOR_PALETTE = 'SET_COLOR_PALETTE'
export const SET_CURRENT_RESULT_ID = 'SET_CURRENT_RESULT_ID'
export const ADD_CONTEXT_VALIDATION_FAILED = 'ADD_CONTEXT_VALIDATION_FAILED'
export const REMOVE_CONTEXT_VALIDATION_FAILED = 'REMOVE_CONTEXT_VALIDATION_FAILED'
export const ADD_SAVE_TO_EXECUTE_IN_SEQUENCE = 'ADD_SAVE_TO_EXECUTE_IN_SEQUENCE'
export const RESET_SAVE_QUEUE = 'RESET_SAVE_QUEUE'
export const ADD_ADDED_IMAGE = 'ADD_ADDED_IMAGE'
export const ADD_REMOVED_IMAGE = 'ADD_REMOVED_IMAGE'
export const RESET_IMAGE_DATA = 'RESET_IMAGE_DATA'
